module.exports = __webpack_public_path__ + "static/banner3-8b2ff69127612a65bd8f2adf7b554e2a.jpg";